<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines" :inline="true">
                <el-form-item label="日期:">
                    <el-date-picker v-model="formData.time" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" size='small' value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
               <el-table-column v-for="(item,ind) in header" :key="ind" :label="item.name" align="center"  >
                    <el-table-column v-show="item.child.length>0" v-for="iteme in item.child"  :key="iteme.key" :label="iteme.name" align="center">
                        <template slot-scope="{row}" >
                                {{row[iteme.key]}}
                        </template>
                    </el-table-column>
                    <template slot-scope="{row}" v-show="item.child.length<1">
                        {{row[item.key]}}
                    </template>
                </el-table-column> 
            </el-table>
             <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
                        :current-page="currentPages" :page-sizes="[15, 30, 50, 100]" :page-size="pagesizes"
                        layout="total, sizes, prev, pager, next, jumper" :total="counts">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                formData:{
                    time:'',
                },
                loading: false,
                tableData: [],
                header:[],
                heights: null,
                 counts: 0,
                currentPages: 1,
                pagesizes: 15,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.search()
            that.getHeight()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 170 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 170 + 'px'
                }
            },
               // 搜索
            begin() {
                let that = this
                that.currentPages = 1
                that.pagesizes = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/Report/getSzmxbbList", {
                        page: that.currentPages,
                        page_count: that.pagesizes,
                        date1:this.formData.time[0]?this.formData.time[0]:'',
                        date2:this.formData.time[1]?this.formData.time[1]:'',
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data
                        that.header = response.data.header
                          that.counts = response.data.count
                    })
                    .catch(error => {})
            },
             handleSizeChanges(val) {
                let that = this
                that.pagesizes = val;
                that.search()
            },
            handleCurrentChanges(val) {
                let that = this
                that.currentPages = val;
                that.search()
            },
        },

    };
</script>


<style>

</style>